
import { useAnalyticsEvents } from '@/core/services/report-service'
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {
      ...useAnalyticsEvents()
    }
  }
})
